// extracted by mini-css-extract-plugin
export default {"root":"IconEmail_root__NP3p+"};